import * as TYPES from './_store/types';
import { dateFormat } from '@/common/format';

function timeFormatList(list) {
    return (
        list &&
        list.map(v => {
            v.publishTimeFormat =
                v.publishTime &&
                dateFormat('MMMM dd, yyyy hh:mm p', new Date(+v.publishTime), this.$pinia);
            return v;
        })
    );
}

function getData(store) {
    

    return Promise.all([
        this.axiosIns.post('/api-graphql', {
            query: '{ categories { title, list{id, name, count},showCategoryCount }}'
        }).then(res => {
            store[TYPES.SET_CATEGORIES](res.data?.categories);
        }),
        this.axiosIns.post('/api-graphql', {
            query: '{ blogRecentPosts { title, list{id, title, publishTime, previewPicture, url},showDate } }'
        }).then(res => {
            let recentPostInfo = res?.data?.blogRecentPosts || {};
            recentPostInfo.list = timeFormatList.call(this, recentPostInfo.list);
            store[TYPES.SET_BLOGRECENTPOSTS](recentPostInfo);
        }),
        this.axiosIns.get('/api-site/shares', {
            params: {
                type: 'blogList',
                id: this.categoryId
            }
        }).then(res => {
            store[TYPES.SET_SHARES](res?.data)
        })
    ])
}

export function fetchDetail(store) {
    
    return this.axiosIns
        .get('/api-site/fetch-detail', {
            params: {
                fetcher: 'blog-content',
                fields: [
                    'blogs',
                    'blogListTitle',
                    'totalPages',
                    'pageSize'
                ],
                categoryId: this.categoryId,
                pageSize: this.defaultPagesize,
                pageNum: this.pageNum
            }
        })
        .then(res => {
            let blogListInfo = res.data;
            blogListInfo.blogs = timeFormatList.call(this, blogListInfo.blogs)
            store[TYPES.SET_BLOGLISTINFO]({ ...res.data, blogListTitle: '' })
        });
}

export async function asyncData(store) {
    await fetchDetail.call(this, store);
    await getData.call(this, store);
}
